import { all, fork } from "redux-saga/effects";

//public
import AccountSaga from "./auth/register/saga";
import AuthSaga from "./auth/login/saga";
import googleLoginSaga from "./auth/googleLogin/saga";
import ForgetSaga from "./auth/forgetpwd/saga";
import ChangeSaga from "./auth/changepwd/saga";
import ProfileSaga from "./auth/profile/saga";
import LayoutSaga from "./layout/saga";

import PointsSaga from "./points/saga";
import StoreMenuSaga from "./storeMenu/saga";
import StoreDetailsSaga from "./storeDetails/saga";
import TopicDetailsSaga from "./topicDetails/saga";
import QuestionSetDetailsSaga from "./questionSetDetails/saga";
import InfoProfileSaga from "./infoProfile/saga";
import FollowersSaga from "./followers/saga";
import ImageMapSaga from "./imageMap/saga";
import userSaga from "./user/saga";

export default function* rootSaga() {
  yield all([
    //public
    fork(AccountSaga),
    fork(AuthSaga),
    fork(googleLoginSaga),
    fork(ForgetSaga),
    fork(ChangeSaga),
    fork(ProfileSaga),
    fork(LayoutSaga),
    fork(PointsSaga),
    fork(StoreMenuSaga),
    fork(StoreDetailsSaga),
    fork(TopicDetailsSaga),
    fork(QuestionSetDetailsSaga),
    fork(InfoProfileSaga),
    fork(FollowersSaga),
    fork(ImageMapSaga),
    fork(userSaga),
  ]);
}
